exports = module.exports = require("../../../web-ai-translation/node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../web-ai-translation/node_modules/css-loader/index.js??ref--8-oneOf-3-1!../../../web-ai-translation/node_modules/postcss-loader/src/index.js??ref--8-oneOf-3-2!../../../web-ai-translation/node_modules/sass-loader/dist/cjs.js??ref--8-oneOf-3-3!bootstrap/dist/css/bootstrap.css"), "");

// module
exports.push([module.id, "", ""]);

// exports
